import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, SIZE } from "baseui/button";
import { Spinner, SIZE as SpinnerSize } from 'baseui/spinner';
import { message } from 'antd';
import macbook from '../../../../../../assets/img/jobhome/Macbook.svg';
import './MainBody.scss';
import emailIcon from '../../../../../../assets/img/email-icon.svg';
import mailSentIcon from '../../../../../../assets/img/mail-sent-check.svg';

const ChallengePageBody = ({ 
    mail_sent = false, 
    sending_error = false, 
    sendDesktopLoginMail, 
    loading, 
    description_heading, 
    description_body,
    showNotification,
    resetNotifications
}) => {
    useEffect(() => {
        if (mail_sent && showNotification) {
            message.success('A login link has been sent to your email. Please use it to access Turing on desktop.');
        }

        if (sending_error && showNotification) {
            message.error('Error Sending Email, Please try again');
        }
        return () => {
            if (mail_sent || sending_error) resetNotifications();
        }
    }, [mail_sent, sending_error, showNotification]);

    return (
        <div className='turing-mobile-home-body centered'>
            <div className='turing-mobile-home-body__heading'>
                {description_heading || 'Switch to desktop or laptop to continue this challenge'}
            </div>
            <div className='turing-mobile-home-body__img-wrapper mb0'>
                <img src={macbook} alt="" />
            </div>
            <div>
                {description_body || 'For the best experience and a fair evaluation, Turing Challenges are only available on desktop or laptop. We can send you an email with a login link, so you can easily pick up where you left off.'}
            </div>
            <Button
                disabled={mail_sent}
                onClick={sendDesktopLoginMail}
                size={SIZE.compact}
                colors={{ backgroundColor: '#2F6AE3', color: '#fff' }}
                overrides={{
                    BaseButton: {
                        style: {
                            width: "100%",
                            gap: "8px"
                        }
                    }
                }}
            >
                {loading && <Spinner $color='#fff' $size={SpinnerSize.small} />}
                <img src={mail_sent ? mailSentIcon : emailIcon} alt="E" />
                {mail_sent ? 'Login link sent to your email' : 'Email login link for desktop'}
            </Button>
        </div>
    );
};

ChallengePageBody.propTypes = {
    mail_sent: PropTypes.bool,
    sending_error: PropTypes.bool,
    sendDesktopLoginMail: PropTypes.func,
    loading: PropTypes.bool,
    description_heading: PropTypes.string,
    description_body: PropTypes.string
};

export default ChallengePageBody;
